import React, { useState } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./Router/constant";

import Login from "./Page/Login";
import Signup from "./Page/Signup";
import VerifyOtp from "./Page/VerifyOtp";
import ForgotPassword from "./Page/ForgotPassword";
import ResetPassword from "./Page/ResetPassword";
import Dashboard from "./Page/Dashboard";
import CompleteProfile from "./Page/CompleteProfile";
import Inquiries from "./Page/Inquiries";
import Operations from "./Page/Operations";
import Message from "./Page/Message";
import Setting from "./Page/Setting";
import Transactions from "./Page/Transactions";
import Documnet from "./Page/Document";
import InquiriesDetails from "./Page/InquiriesDetails";
import OperationDetails from "./Page/OperationDetails";
import Product from "./Page/Product";
import AddProduct from "./Page/AddProduct";
import QuimeraOrders from "./Page/QuimeraOrders";
import QuimeraOrderDetails from "./Page/QuimeraOrderDetails";
import RequireAuth from "./Router/RequireAuth";
import RequireGuest from "./Router/RequireGuest";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Sidebar from "./Components/Sidebar";

function PublicLayout() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 p-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen((previous) => !previous);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="app-layout">
      <Sidebar sidebarOpen={sidebarOpen} closeSidebar={closeSidebar} />

      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      <div className="app-content">
        <Header onToggleSidebar={toggleSidebar} />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default function RouteComponent() {
  return (
    <Routes>
      <Route element={<RequireGuest />}>
        <Route element={<PublicLayout />}>
          <Route path={RoutesPaths.LOGIN} element={<Login />} />
          <Route path={RoutesPaths.SIGNUP} element={<Signup />} />
          <Route path={RoutesPaths.VERIFYOTP} element={<VerifyOtp />} />
          <Route path={RoutesPaths.FORGOTPASSWORD} element={<ForgotPassword />} />
          <Route path={RoutesPaths.RESETPASSWORD} element={<ResetPassword />} />
        </Route>
      </Route>
      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          <Route path={RoutesPaths.DASHBOARD} element={<Dashboard />} />
          <Route path={RoutesPaths.COMPLETEPROFILE} element={<CompleteProfile />} />
          <Route path={RoutesPaths.INQUIRIES} element={<Inquiries />} />
          <Route path={RoutesPaths.ORDER} element={<Operations />} />
          <Route path={RoutesPaths.QUIMERA_ORDERS} element={<QuimeraOrders />} />
          <Route path={RoutesPaths.QUIMERA_ORDER_DETAILS} element={<QuimeraOrderDetails />} />
          <Route path={RoutesPaths.MESSAGE} element={<Message />} />
          <Route path={RoutesPaths.SETTING} element={<Setting />} />
          <Route path={RoutesPaths.TRANSACTIONS} element={<Transactions />} />
          <Route path={RoutesPaths.DOCUMENT} element={<Documnet />} />
          <Route path={RoutesPaths.INQUIRIESDETAILS} element={<InquiriesDetails />} />
          <Route path={RoutesPaths.ORDERDETAILS} element={<OperationDetails />} />
          <Route path={RoutesPaths.PRODUCT} element={<Product />} />
          <Route path={RoutesPaths.ADDPRODUCT} element={<AddProduct mode="add" />} />
          <Route path={RoutesPaths.VIEWPRODUCT} element={<AddProduct mode="view" />} />
          <Route path={RoutesPaths.EDITPRODUCT} element={<AddProduct mode="edit" />} />
        </Route>
      </Route>
    </Routes>
  );
}